import { gql } from '@apollo/client'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'
import { DailyCheckInShopRewardFragment } from '@src/graphql/fragment/reward'

export default gql`
  query GetDailyCheckInShopItems($input: DailyCheckInShopItemsInput!) {
    getDailyCheckInShopItems(input: $input) {
      edges {
        cursor
        node {
          ... on DailyCheckInShop {
            itemCost {
              UserAssetName
              quantity
              metaKey
            }
            displayOrder
            remainCount
            shopItemID
            totalCount
            shopRewards {
              ...DailyCheckInShopReward
            }
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${DailyCheckInShopRewardFragment}
  ${PageInfoFragment}
`
